// React
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TagModel, TagsCollection } from '@models/tag';
import SaveIcon from '@material-ui/icons/Save';
import TextInput from '@/components/shared/TextInput';

import http from '@/utils/http';

class TagForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tag: props.tag,
      tagName: '',
      existingTags: [],
    };
  }

  // Names already used on this kind of record, offered as suggestions. Free text
  // still works - this narrows the "five spellings of Chargeback" problem without
  // blocking a genuinely new tag.
  //
  // Shaped { code, name } because TextInput's suggestion dropdown was written for
  // the state picker on the shipping form. Same widget, no new one.
  componentDidMount() {
    const { tag } = this.state;

    http.get(tag.routes.all, { params: { taggable_model: tag.taggable_model } })
      .then((response) => {
        this.setState({
          existingTags: response.data.map((t) => ({ code: t.name, name: t.name, color: t.color })),
        });
      })
      .catch(() => {
        // Suggestions are a convenience; typing still works without them.
      });
  }

  handleSuggestionPick = (name) => {
    this.setState({ tagName: name });
  };

  handleFormSubmit = (event) => {
    event.preventDefault();

    // Read from props, not a copy taken when the form opened. The form stays open
    // while tags are removed behind it, so a snapshot went stale: removing a tag
    // and re-adding it still reported "Tag exists".
    //
    // Case-insensitive because acts-as-taggable-on matches that way - "BANNED"
    // and "Banned" are the same tag, and the duplicate check has to agree.
    const { tagName } = this.state;
    const tagUnique = this.props.tags.models
      .every((tag) => tag.name.toLowerCase() !== tagName.toLowerCase());
    if (tagUnique) {
      this.createTag();
    } else {
      window.flashMessages.addMessage({ type: 'error', text: 'Tag exists' });
    }
  }

  createTag = () => {
    const { tag, tagName } = this.state;
    const newTag = new TagModel({ ...tag });
    newTag.set('name', tagName);

    http.post(tag.routes.all, { tag: newTag.attributes })
      .then((response) => {
        this.onSuccessSubmit(response);
      })
      .catch(() => {
        this.onError();
      });
  }

  onSuccessSubmit = (response) => {
    this.props.onSubmitForm(new TagModel(response.data));
    window.flashMessages.addMessage({ type: 'success', text: 'Tag has been created' });
  }

  onError = () => {
    window.flashMessages.addMessage({ type: 'error', text: 'Error on add tag - try again' });
  }

  handleInputChange = (event) => {
    this.setState({ tagName: event.target.value });
  };

  render() {
    const { existingTags, tagName } = this.state;

    return (
      <form
        onSubmit={this.handleFormSubmit}
        className="tag__form row mx-0"
      >
        <TextInput
          isRequired="required"
          value={tagName}
          onChange={this.handleInputChange}
          customClass="with-button"
          placeholder="Pick or type a tag"
          statesList={existingTags}
          showStateSuggestion={true}
          handleStateChange={this.handleSuggestionPick}
        />
        <button
          type="submit"
          className="input-button btn btn-sm btn-primary"
        >
          <SaveIcon />
        </button>
      </form>
    );
  }
}

TagForm.propTypes = {
  tag: PropTypes.instanceOf(TagModel).isRequired,
  tags: PropTypes.instanceOf(TagsCollection),
};

export default TagForm;
